import { defineInlineEdit } from "../../../../components/MobileList/inlineEdit";

/**
 * Reproduces views/pins/form's update payload. The list row is a different
 * projection (it shows `item_name`, not the `item` object the payload needs),
 * so the detail is fetched first.
 *
 * Quirk carried over deliberately: the slice's setById never populates
 * `cash_paid`, so the dialog has always PUT the empty initial value. Keeping
 * that here means an inline save behaves exactly like a dialog save.
 *
 * `pin_number` is not editable — the dialog validates its length against the
 * item's `digit_length`, which the card has no way to check. `status` is a
 * workflow field and `item`/`supplier` are relations the dialog re-picks
 * together, so those stay in the dialog too.
 */
export default defineInlineEdit({
  api: "pins",
  permission: "pin_edit",
  hydrate: true,
  toPayload: (detail) => ({
    serial_number: detail.serial_number ?? "",
    pin_number: detail.pin_number,
    expiry_date: detail.expiry_date,
    buying_price: detail.buying_price,
    item_id: detail.item?.id ?? detail.item_id,
    status: detail.status,
    supplier_id: detail.supplier?.id ?? detail.supplier_id,
    cash_paid: "",
  }),
  fields: {
    serial_number: {
      label: "الرقم التسلسلي",
      type: "text",
      required: true,
      inputProps: { dir: "ltr" },
    },
    buying_price: { label: "سعر الشراء", type: "number", required: true },
    expiry_date: { label: "تاريخ النفاذ", type: "date" },
  },
});
